import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { map } from 'rxjs/operators';
import { DialogService } from 'src/app/services/dialog.service';
import { Feature } from '../auth/account.model';
import { BrandService } from '../services/brand.service';
import { PlatformService } from '../services/platform.service';
import { DIALOG_SERVICE } from './login.guard';

/**
 * 기능 가드
 */
export const featureGuard = (...featureList: Feature[]): CanActivateFn => {
  return (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const router = inject(Router);
    const featureService = inject(BrandService);
    const dialogServiceType = inject(DIALOG_SERVICE);
    const dialogService: DialogService = inject(dialogServiceType);
    const platformService = inject(PlatformService);

    // 서버는 무조건 통과
    if (platformService.isPlatformServer) {
      return true;
    }

    if (featureService.isAvail(...featureList)) {
      return true;
    }

    return dialogService.alert('No feature').pipe(
      map(() => {
        return router.createUrlTree(['/home']);
      }),
    );
  };
};
